import Select from "react-select";

const defaultStyles = {
    control: (base) => ({
        ...base,
        minHeight: 56,
        borderRadius: 8,
        backgroundColor: "#f1f5f9",
        boxShadow: "none",
        borderColor: "transparent",
        ":hover": { borderColor: "transparent" },
        paddingLeft: 4,
        paddingRight: 4,
        marginTop: 4,
    }),
    option: (base, state) => ({
        ...base,
        color: "#101828",
        cursor: "pointer",
        fontSize: 16,
        fontStyle: "normal",
        fontWeight: 450,
        lineHeight: "24px",
        letterSpacing: "-0.4px",
        backgroundColor: state.isSelected ? "#F4F2FC" : state.isFocused ? "#F8F7FF" : "#FFFFFF",
        ":active": {
            backgroundColor: "#F4F2FC",
        },
    }),
    multiValue: (base) => ({
        ...base,
        borderRadius: 999,
        backgroundColor: "#E5E7F5",
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: "#4F5372",
        fontSize: 16,
        fontStyle: "normal",
        fontWeight: 350,
        lineHeight: "24px",
        letterSpacing: "-0.24px",
    }),
    placeholder: (base) => ({
        ...base,
        color: "#8A8FA6",
        fontSize: 16,
        fontStyle: "normal",
        fontWeight: 350,
        lineHeight: "24px",
        letterSpacing: "-0.24px",
    }),
    input: (base) => ({
        ...base,
        fontSize: 16,
        fontStyle: "normal",
        fontWeight: 350,
        lineHeight: "24px",
        letterSpacing: "-0.24px",
    }),
    menu: (base) => ({
        ...base,
        zIndex: 10000,
        borderRadius: 12,
        boxShadow:
            "-16px -16px 16px -4px rgba(16, 24, 40, 0.03), 16px 16px 32px -4px rgba(16, 24, 40, 0.08)",
        border: "1px solid #E6E8F9",
        overflow: "hidden",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 10000 }),
    menuList: (base) => ({
        ...base,
        padding: 8,
        maxHeight: base.maxHeight || 280,
    }),
};

const MultiSelectDropdown = ({
    value = [],
    options = [],
    onChange,
    label,
    placeholder = "Select options",
    instanceId,
    styles,
    maxMenuHeight = 280,
    minMenuHeight = 120,
    menuPlacement = "auto",
}) => {
    const selectedOptions = options.filter((option) => value.includes(option.value));

    return (
        <div>
            {label && (
                <label className="aku-body-small-medium block text-[#475467] mb-1">{label}</label>
            )}
            <Select
                instanceId={instanceId}
                isMulti
                closeMenuOnSelect={false}
                options={options}
                styles={{ ...defaultStyles, ...styles }}
                menuPosition="fixed"
                menuPlacement={menuPlacement}
                maxMenuHeight={maxMenuHeight}
                minMenuHeight={minMenuHeight}
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                placeholder={placeholder}
                value={selectedOptions}
                onChange={(selected) =>
                    onChange?.((selected || []).map((option) => option.value))
                }
            />
        </div>
    );
};

export default MultiSelectDropdown;
